import { colors } from '@styles/theme'
import { PiArrowsClockwiseBold, PiHeartFill, PiUserPlusFill } from 'react-icons/pi'

const NotificationLikeIcon = ({ ...rest }) => <PiHeartFill fill='#FF007F' {...rest} />

const NotificationFollowIcon = ({ ...rest }) => <PiUserPlusFill fill={colors.statusColors.chatting('primary')} {...rest} />

const NotificationRepostIcon = ({ style, ...rest }) => (
  <PiArrowsClockwiseBold
    fill={colors.success(500)}
    stroke={colors.success(500)}
    strokeWidth={4}
    style={{ transform: 'rotate(90deg)', ...style }}
    {...rest}
  />
)

export {
  NotificationLikeIcon,
  NotificationRepostIcon,
  NotificationFollowIcon
}
